<template>
    <comp-9-art-adherence :section="9" :page="59" :nextDisabled="nextDisabled">
        <p>
            AND… you also shared that you don’t take ART every day. Meaning, there’s a gap between these 3 important points and your actual behavior. Why do you
            think there’s such a gap for you? (choose all that apply)
        </p>
        <v-checkbox v-for="gap in artGaps" :key="gap.id" :label="gap.text" :value="gap.id" v-model="selectedGaps" hide-details dense></v-checkbox>
    </comp-9-art-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { filter, map, forEach } from 'lodash';

export default {
    data: function() {
        return {
            selectedGaps: []
        };
    },
    computed: {
        artSelectedGaps() {
            let artSelectedGaps = map(filter(this.artGaps, 'selected'), 'id');

            if (artSelectedGaps) {
                return artSelectedGaps;
            } else return [];
        },
        artGaps: sync('section9/artAdherenceGaps')
    },
    methods: {
        nextDisabled() {
            return this.selectedGaps.length === 0;
        }
    },
    watch: {
        selectedGaps() {
            forEach(this.artGaps, o => {
                if (this.selectedGaps.includes(o.id)) {
                    o.selected = true;
                } else {
                    o.selected = false;
                }
            });
        }
    },
    mounted() {
        this.selectedGaps = this.artSelectedGaps;
    }
};
</script>
